import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Components
import Help from "../../components/Help.js";

// Style
import {flex} from "../../style/components/mixins.js";
import {pad} from "../../style/components/variables.js";
import {bp} from "../../style/components/breakpoints.js";
import {Text, Button, Label, Inline} from "../../style/components/general.js";

export const AccountRow = ({label, help, children, indent = false}) => (
  <InfoItem>
    {label && (
      <InfoLabel>
        {label}
        {help && (
          <>
            &nbsp;
            <Help title={label}>{help}</Help>
          </>
        )}
      </InfoLabel>
    )}

    <InfoCell>
      <Inline>
        {indent && <>&nbsp;&nbsp;</>}
        {children}
      </Inline>
    </InfoCell>
  </InfoItem>
);

AccountRow.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  help: PropTypes.string,
  indent: PropTypes.bool
};

export const InfoItem = styled.div`
  position: relative;
  padding: ${pad}px;
  width: 100%;
  min-width: min-content;
  gap: ${pad}px;

  ${bp(2)} {
    ${flex("row", "wrap", "start", "center")}
    padding-left: 20px;
  }
`;

export const InfoLabel = styled(Label)`
  width: 35%;
  align-self: start;
  margin-bottom: 0;
  font-weight: bold;
`;

export const InfoCell = styled.div`
  width: 65%;
`;

export const InfoText = styled(Text)`
  color: ${({theme}) => theme.secondary};
`;

export const Save = styled(Button)`
  position: absolute;
  bottom: 0;
  right: 0;
  margin: ${pad}px;
`;
